import FavouritesButton from "./FavouritesButton";

export default FavouritesButton;
